import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  bps_id: '',
  bps_date: '',
  equip_id: '',
  crane_id: '',
  bps_fotosparepart: '',
  foto_sparepart: '',
  bps_fotopemakaian: '',
  foto_pemakaian: '',
  bps_fototsr: '',
  foto_tsr: '',
  rowid: '',
  log: [],
  record: {
    created_by: '',
    created_date: '',
    modified_by: '',
    modified_date: '',
  },
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
};

const ops07bpsSlice = createSlice({
  name: 'ops07bps',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
    },
  },
});

export const {
  setActiveTab,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  updateFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  clearModuleState,
} = ops07bpsSlice.actions;

export default ops07bpsSlice.reducer;
